import cn from 'classnames';
import { Dispatch, FC, SetStateAction } from 'react';
import { useIntl } from 'react-intl';

import { useAppSelector } from '@/shared/hooks';

import { composedModel } from '@/entities/composed';

import { DentalPhotoCheckbox } from '../DentalPhotoCheckbox/DentalPhotoCheckbox';

import styles from './DentalPhotosStep.module.scss';

type DentalPhotosStepProps = {
  selectedIDs: string[];
  className?: string;
  testID?: string;
  setSelectedIDs: Dispatch<SetStateAction<string[]>>;
};

export const DentalPhotosStep: FC<DentalPhotosStepProps> = (props) => {
  const { className, testID, selectedIDs, setSelectedIDs } = props;

  const { formatMessage } = useIntl();

  const albums = useAppSelector(
    composedModel.selectors.selectAlbumsWithVideosRemoved,
  );

  if (albums.length === 0) {
    return null;
  }

  return (
    <div
      data-testid={testID}
      className={cn(styles.container, className)}
      data-component="dental-photos-step"
    >
      <div className={styles.title}>
        <h5 className="h5">
          {formatMessage({
            id: 'orderReportModal.dentalPhotoStep.title',
            defaultMessage: 'Step 3: Select dental photo',
          })}{' '}
          (
          {formatMessage({
            id: 'global.optional',
            defaultMessage: 'Optional',
          }).toLowerCase()}
          )
        </h5>

        <span className={cn(styles.counter, 'p1')}>
          {formatMessage(
            {
              id: 'orderReportModal.dentalPhotoStep.counter',
              defaultMessage: '{count} selected',
            },
            { count: selectedIDs.length },
          )}
        </span>
      </div>

      <div className={styles.innerContainer}>
        {albums.map(({ ID, StudyAssetIDs }) => (
          <div key={ID} className={styles.album}>
            {StudyAssetIDs.map((assetID) => (
              <DentalPhotoCheckbox
                key={assetID}
                name={assetID}
                photoID={assetID}
                size="preview"
                checked={selectedIDs.includes(assetID)}
                onChange={() =>
                  setSelectedIDs((prevIDs) =>
                    prevIDs.includes(assetID)
                      ? prevIDs.filter((prevID) => prevID !== assetID)
                      : prevIDs.concat(assetID),
                  )
                }
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
